"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _client = require("@apollo/client");
var _getApolloRestClient = require("./getApolloRestClient");
var _logger = _interopRequireDefault(require("./logger"));
const QUERY = "\n  query banner {\n    banner @rest(path: \"\") {\n      bannerContent\n      modalContent\n    }\n  }\n";
const fetchNavigationBanner = async _ref => {
  let {
    bffUrl
  } = _ref;
  const bannerRepositoryUrl = "".concat(bffUrl, "/navigation/banner");
  const client = (0, _getApolloRestClient.getApolloRestClient)(bannerRepositoryUrl);
  const query = (0, _client.gql)(QUERY);
  return client.query({
    query,
    fetchPolicy: 'no-cache',
    errorPolicy: 'all'
  }).then(response => {
    const {
      bannerContent,
      modalContent
    } = response.data.banner;
    console.log('>>>>> response', response);
    //if banner is not displayed, then modal is not displayed
    if (!bannerContent || !JSON.parse(bannerContent).textBanner) {
      const stringifiedResponse = JSON.stringify(response);
      _logger.default.error('Error fetching shared header items', stringifiedResponse);
      throw new Error(stringifiedResponse);
    }
    return {
      bannerContent: JSON.parse(bannerContent),
      modalContent: JSON.parse(modalContent)
    };
  }).catch(err => {
    _logger.default.error('Error fetching shared header banner items', err);
    throw err;
  });
};
var _default = exports.default = fetchNavigationBanner;